module.exports = __webpack_public_path__ + "img/lock2.72043604.png";